module.exports = __webpack_public_path__ + "media/images/carousel_left-63a5d3d869ea2354f707a5355e49fc89.svg";